import { fetchAuthSession } from 'aws-amplify/auth';

const getIdToken = async () => {
    try {
      const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
      // console.log('idToken', idToken)
      const token = idToken?.toString?.() ?? (idToken ? String(idToken) : undefined);
      if (token) {
        try {
          sessionStorage.setItem('iquote_idToken', token);
        } catch {
          // ignore storage failures (private mode, quota, etc)
        }
      }
      return token;
    } catch (err) {
      console.log(err);
    }
};

export async function client(apiURL, endpoint, { body, method, ...customConfig } = {}) {

    const headers = { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await getIdToken()}`,
        'SourceApp': 'iQuoteNG'
     }
  
    const config = {
      method: method,
      ...customConfig,
      headers: {
        ...headers,
        ...customConfig.headers,
      },
    }
  
  if (body instanceof FormData) { // checks if the body is a binary object (e.g. an excel file)
    config.body = body;
    delete config.headers['Content-Type']; // Let browser handle it
  } else if (body) {
    config.body = JSON.stringify(body);
  }
  
    let data, response
    try {
      response = await window.fetch(`${apiURL}${endpoint}`, config)

      const contentType = response.headers.get("content-type")
      if (contentType?.includes("application/json")) {
        data = await response.json()
      } else if (isBinaryResponse(contentType)) {
        data = await response.blob()
      } else {
        data = await response.text()
      }

      if (!response.ok && data === "") {
        const msg = `An error occurred while trying to access ${apiURL}${endpoint} (StatusCode: ${response.status})` //set a message when the requested Api is up, not returned ok and has no response
        data = msg
        console.log(msg)
      }
    } catch (err) {
      // executes when the requested Api is down (response will be undefined)
      data = `An error occurred while trying to access ${apiURL}${endpoint}`
    } finally {      
      // Return a result object similar to Axios
      return {
        status: response?.status ?? 500,
        ok: response?.ok ?? false,
        data,
        headers: response?.headers ?? '',
        url: response?.url ?? ''
      }
    }
  }

  const isBinaryResponse = (contentType) => {
    if (!contentType) return false;

    const lower = contentType.toLowerCase();
    return lower.startsWith("application/octet-stream") ||
          lower.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
          lower.includes("application/pdf") ||
          lower.includes("application/zip");
  }
  
  client.get = function (apiURL, endpoint, customConfig = {}) {
    return client(apiURL, endpoint, { method: 'GET', ...customConfig })
  }
  
  client.post = function (apiURL, endpoint, body, customConfig = {}) {
    logBody(body)
    return client(apiURL, endpoint, { body, method: 'POST', ...customConfig })
  }

  client.put = function (apiURL, endpoint, body, customConfig = {}) {
    logBody(body)
    return client(apiURL, endpoint, { body, method: 'PUT', ...customConfig })
  }

  client.delete = function (apiURL, endpoint, customConfig = {}) {
    return client(apiURL, endpoint, { method: 'DELETE', ...customConfig })
  }

  const logBody = (body) => {
    console.log('request body', body instanceof FormData ? '[FormData]' : body);
  }
  